// ABOUTME: Back-office switch for one company's staff-only settings: today, the employer shortlist CSV.
// ABOUTME: Saves on change through PUT /companies/:id/settings, apart from the profile form employers also use.
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useGetCompanySettingsQuery,
  useUpdateCompanySettingsMutation,
} from '../../../../../store/modules/companies';

const CompanySettingsToggle: FC<{ companyId: number }> = ({ companyId }) => {
  const [t] = useTranslation('global');
  const { data, isLoading } = useGetCompanySettingsQuery(companyId);
  const [saveSettings, { isLoading: isSaving }] =
    useUpdateCompanySettingsMutation();

  return (
    <label
      className="flex items-center gap-2 text-sm mt-4"
      htmlFor={`shortlist-csv-${companyId}`}
    >
      <input
        id={`shortlist-csv-${companyId}`}
        type="checkbox"
        checked={data?.ShortlistCsvExport ?? false}
        disabled={isLoading || isSaving || !data}
        onChange={(event) =>
          saveSettings({ companyId, ShortlistCsvExport: event.target.checked })
        }
      />
      {t('CompaniesTable.ShortlistCsvExport')}
    </label>
  );
};

export default CompanySettingsToggle;
